export default {
    name: 'all',
    created(){
       
    }
}



// WEBPACK FOOTER //
// ./src/components/vouchers/all/all.js